'use client';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

/**
 * TableCell component, used to display the cells of a table. Renders a native HTML td element.
 *
 * @example
 * <TableCell>John</TableCell>
 */
const TableCell = forwardRef(function TableCell(rest, ref) {
    return jsx("td", { ref: ref, ...rest });
});

export { TableCell };
